import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Header, Icon, MessageProps, Transition } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import { required } from 'utils/validatorUtils';
import { FormApi } from 'final-form';
import Input from 'components/final-form/Input';
import LanguageDropdown from 'routes/login/segments/LanguageDropdown';

interface Props extends MessageSourceProps {
  success: boolean,
  error: boolean,
  errorMessage: string,
  submitting: boolean,
  visible: boolean,
  form: FormApi,
  transitionToCredentials: () => void,
  renderMessage: (header: string, text: string, messageProps: MessageProps) => React.ReactNode
}

class ForgotPasswordSegment extends Component<Props> {

  render(): React.ReactNode {

    const {getMessage, getMessageWithNamedParams, transitionToCredentials, renderMessage} = this.props;
    const {success, error, errorMessage, visible, form, submitting} = this.props;

    const email = form.getState().values.email;

    const successHeader = getMessage('resetPassword.success');
    const successText = getMessageWithNamedParams('resetPassword.sentPasswordReset', {email: email});

    const errorHeader = getMessage('resetPassword.email');

    const validator = visible ? required : undefined;

    return (
        <Transition animation={"fade left"} duration={400} visible={visible}>
          <div>
            <Header as='h2' icon textAlign='center'>
              <Icon name='mail' circular/>
              <Header.Content>{getMessage('login.enterEmail')}</Header.Content>
            </Header>
            <Grid verticalAlign="middle">
              <Grid.Row verticalAlign="middle">
                <Grid.Column>
                  <Field
                      name='email'
                      component={Input}
                      placeholder={getMessage("resetPassword.email")}
                      autoComplete="on"
                      icon='mail'
                      validate={validator}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Button type='submit' primary fluid disabled={submitting}>
                  {getMessage("resetPassword.send")}
                </Button>
              </Grid.Row>
              <Button basic fluid onClick={transitionToCredentials} disabled={submitting} loading={submitting}>
                {getMessage("resetPassword.goToLogin")}
              </Button>
              <Grid.Row>
                <Grid.Column>
                  {success && renderMessage(successHeader, successText, {positive: true})}
                  {error && renderMessage(errorHeader, errorMessage, {negative: true})}
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <LanguageDropdown/>
          </div>
        </Transition>
    );
  }
}

export default withMessages(ForgotPasswordSegment);
